import { Mod } from "@/services/api";

export default {
   actions: {
      async editDateBilling(_commit, payload) {
         return Mod.find("Billing", "billing").edit(payload);
      }
   }
};
